import { Component, computed, inject, input, signal } from '@angular/core';
import { Menu, MenuDefault, MenuWithSubMenu } from '../../../types/left-menu.types';
import { BaseLeftMenuItemComponent } from '../../base-left-menu-item/base-left-menu-item.component';
import { smoothShowHideHeight, smoothShowHideWidth } from '../../../../../../shared/animations/smoothShowHideAnimations';
import { LeftMenuService } from "../../../services/left-menu.service";

@Component({
  selector: 'app-collapsed-submenu-left-menu-item-list',
  standalone: true,
  imports: [],
  templateUrl: './collapsed-submenu-left-menu-item-list.component.html',
  styleUrl: './collapsed-submenu-left-menu-item-list.component.scss',
  animations: [
    smoothShowHideHeight,
    smoothShowHideWidth
  ]
})
export class CollapsedSubmenuLeftMenuItemListComponent extends BaseLeftMenuItemComponent {
  isSubmenuOpen = input<boolean>(false);

  private leftMenuService: LeftMenuService = inject(LeftMenuService);

  private submenusOpenedStateController = signal<{ [key: string]: boolean }>({});
  private clickPositions = signal<{ [key: string]: number }>({});
  public menuWithSubMenu = computed(() => this.menu() as MenuWithSubMenu);

  public isSmallSubmenuActive(submenuItem: Menu): boolean {
    submenuItem = submenuItem as MenuDefault;

    return this.router.url.includes(submenuItem.url);
  }

  public handleDefaultMenuClick(submenuItem: Menu): void {
    submenuItem = submenuItem as MenuDefault;
    super.handleClick();
    this.router.navigate([submenuItem.url]).then();
  }

  public handleSubmenuMenuClick(submenuId: string, event: MouseEvent): void {
    const rect = (event.currentTarget as HTMLElement).getBoundingClientRect();
    this.clickPositions()[submenuId] = event.clientY - rect.top;
    this.switchSubmenuState(submenuId);
  }

  public isSpecifiedSubmenuOpen(submenuId: string): boolean {
    return this.submenusOpenedStateController()[submenuId];
  }

  public closeAllCollapsedSubmenus(): void {
    this.submenusOpenedStateController.set({});
  }

  public isSubmenuActive(submenuId: string): boolean {
    return this.submenusOpenedStateController()[submenuId];
  }

  public getSubmenuTopPosition(submenuId: string): number {
    return this.clickPositions()[submenuId] + 18 || 0;
  }

  public isMenuAvailableToCurrentUser(menu: Menu): boolean {
    return this.leftMenuService.isMenuAvailableToCurrentUser(menu);
  }

  private switchSubmenuState(submenuId: string): void {
    const currentSubmenuState: boolean = this.submenusOpenedStateController()[submenuId] ?? false;
    this.closeAllCollapsedSubmenus();
    this.submenusOpenedStateController()[submenuId] = !currentSubmenuState;
  }
}
